import React from "react";
import { SESSION_KEY } from "../constants";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";

// شبكة أمان: تلتقط أي خطأ في الواجهة وتعرض رسالة بدل الشاشة البيضاء.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(err) {
    return { err };
  }
  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    console.error("App crash:", err, info);
  }
  handleBackToLogin = () => {
    try { localStorage.removeItem(SESSION_KEY); } catch {}
    signOut(auth).catch(() => {});
    window.location.href = "/";
  };
  render() {
    if (this.state.err) {
      const msg = String(this.state.err?.message || this.state.err || "");
      const btn = { border: "none", padding: "11px 22px", borderRadius: 10, fontWeight: 700, cursor: "pointer", fontFamily: "Cairo,sans-serif", fontSize: 14 };
      return (
        <div style={{ minHeight: "calc(100vh * var(--vpc, 1))", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Cairo,sans-serif", direction: "rtl", padding: 24, background: "#f8fafc" }}>
          <div style={{ maxWidth: 440, textAlign: "center", background: "#fff", padding: 28, borderRadius: 16, boxShadow: "0 8px 30px rgba(0,0,0,0.08)" }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>⚠️</div>
            <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 8, color: "#334155" }}>صار خطأ غير متوقع</div>
            <div style={{ color: "#64748b", fontSize: 14, marginBottom: 18 }}>حاول تحديث الصفحة، أو ارجع لتسجيل الدخول.</div>
            <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
              <button onClick={() => window.location.reload()} style={{ ...btn, background: "#4a6060", color: "#fff" }}>تحديث الصفحة</button>
              <button onClick={this.handleBackToLogin} style={{ ...btn, background: "#f1f5f9", color: "#334155" }}>العودة لتسجيل الدخول</button>
            </div>
            {msg && <div style={{ marginTop: 18, fontSize: 11, color: "#94a3b8", direction: "ltr", textAlign: "left", background: "#f8fafc", padding: 10, borderRadius: 8, wordBreak: "break-word" }}>{msg}</div>}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
